export default "__VITE_ASSET__molTWyZl__"